let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6sgZC")).then(() => parcelRequire('b5zD1'));